"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecruitmentContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const recruitment_request_1 = require("./recruitment.request");
const recruitment_response_1 = require("./recruitment.response");
const c = (0, core_1.initContract)();
exports.RecruitmentContract = c.router({
    create: {
        method: 'POST',
        path: '/',
        body: recruitment_request_1.CreateRecruitmentRequestSchema,
        responses: {
            201: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    search: {
        method: 'GET',
        path: '/',
        query: recruitment_request_1.RecruitmentSearchQuerySchema,
        responses: {
            200: recruitment_response_1.RecruitmentSearchListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/recruitment' });
